module.exports = require("urijs/src/URITemplate");